import styled from 'styled-components';
import { Download } from '@styled-icons/boxicons-regular/Download';
import { Error } from '@styled-icons/boxicons-regular/Error';

export const DownloadIcon = styled(Download)`
  width: 1rem;
  margin-right: 0.2rem;
`;

export const ErrorIcon = styled(Error)`
  width: 1rem;
  margin-right: 0.2rem;
`;
